var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"hero"},[_c('div',{staticClass:"hero__logo"},[_c('img',{attrs:{"src":_vm.logo,"alt":"Axen Energia"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }